module.exports = __webpack_public_path__ + "img/que.b21feae1.svg";